'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { usePermissao } from '@/shared/hooks/usePermissao';
import { useCertificadoAcessosSentenca } from '../../hooks/useCertificadoAcessosSentenca';
import type { DocumentoEncerramentoContainerProps } from '../../types/encerramento.types';
import { rotaProcessoPorOrigem } from '../../utils/rotaProcessoPorOrigem';
import { CertificadoAcessosSentencaView } from './certificado-acessos-sentenca/CertificadoAcessosSentencaView';
export function CertificadoAcessosSentencaContainer(t0) {
  const $ = _c(15);
  const {
    processoId,
    origem
  } = t0;
  const router = useRouter();
  const {
    certificado,
    isLoading,
    error,
    semPermissao,
    naoPublicada,
    recarregar,
    isDownloadingPdf,
    baixarPdf,
    imprimir
  } = useCertificadoAcessosSentenca(processoId, origem);
  const {
    pode
  } = usePermissao();
  const podeBaixarPdf = origem !== "secretaria" || pode("processos.baixar_documentos");
  let t1;
  if ($[0] !== origem || $[1] !== processoId || $[2] !== router) {
    t1 = () => {
      router.push(rotaProcessoPorOrigem(origem, processoId));
    };
    $[0] = origem;
    $[1] = processoId;
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleVoltar = t1;
  const t2 = podeBaixarPdf ? baixarPdf : undefined;
  let t3;
  if ($[4] !== certificado || $[5] !== error || $[6] !== handleVoltar || $[7] !== imprimir || $[8] !== isDownloadingPdf || $[9] !== isLoading || $[10] !== naoPublicada || $[11] !== recarregar || $[12] !== semPermissao || $[13] !== t2) {
    t3 = <CertificadoAcessosSentencaView certificado={certificado} error={error} isDownloadingPdf={isDownloadingPdf} isLoading={isLoading} naoPublicada={naoPublicada} onBaixarPdf={t2} onImprimir={imprimir} onTentarNovamente={recarregar} onVoltar={handleVoltar} semPermissao={semPermissao} />;
    $[4] = certificado;
    $[5] = error;
    $[6] = handleVoltar;
    $[7] = imprimir;
    $[8] = isDownloadingPdf;
    $[9] = isLoading;
    $[10] = naoPublicada;
    $[11] = recarregar;
    $[12] = semPermissao;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}